import PropTypes from 'prop-types';

const EmphasisIcon = ({ size, fill, ...other }) => (
  <div style={{ fontSize: size }} {...other}>
    <svg width="1em" height="1em" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M26.366 26.366V11.944h-4.732v14.422h4.732zm0 9.69v-4.845h-4.732v4.845h4.732zM6.986 7.1C11.718 2.366 17.39 0 24 0c6.61 0 12.263 2.347 16.958 7.042C45.653 11.737 48 17.39 48 24c0 6.61-2.347 12.263-7.042 16.958C36.263 45.653 30.61 48 24 48c-6.61 0-12.263-2.347-16.958-7.042C2.347 36.263 0 30.61 0 24c0-6.61 2.329-12.244 6.986-16.901z"
        fill={fill}
        fillRule="nonzero"
      />
    </svg>
  </div>
);

EmphasisIcon.propTypes = {
  size: PropTypes.string,
  fill: PropTypes.string,
};

EmphasisIcon.defaultProps = {
  size: 'inherit',
  fill: 'currentColor',
};

export default EmphasisIcon;
